/**
 * FirmaKartPage.jsx — Firma Kartı (Firma Bilgileri detay sayfası)
 * Route: /Firma/FirmaKart
 *
 * "Firma Ana Sayfa"daki (FirmaAnasayfaListPage.jsx) "Firma Kartına Git" butonunun
 * hedefi — grup 9 (Firma Moderatör) ve 19 (Firma Admin) için salt okunur firma
 * kartı: Firma Bilgileri (temel bilgiler + katalog), Firma Yetkilileri (rol
 * gruplarına ayrılmış firma yetkilileri + portal kullanıcıları + görüşme notları)
 * ve Evraklar sekmeleri.
 *
 * Evraklar sekmesi: Vergi Levhası/İmza Sirküsü/Fuar Sözleşmesi salt okunur durum
 * kutucuklarının yanına, eskiden Personel Detayı'nda (bkz.
 * FirmaPersonelDetailPage.jsx) her personel için tekrar tekrar gösterilen firma
 * çapındaki 3 belgenin (Firma İSG Taahhütnamesi/İş Yeri Hekimi Ataması/İş
 * Güvenliği Uzmanı Ataması) yükleme kutucukları taşındı — personel başına değil
 * firma başına tek kayıt oldukları için tek bir yerden yönetiliyorlar (bkz.
 * firmaProfileService.js'teki uploadFirmaGrupBelgesi). 2026-07-22:
 * eski salt-okunur "Taahhütname" kutucuğu buradan kaldırıldı (profile.taahhutnameStatus
 * alanı Ana Sayfa özet panelinde hâlâ kullanıldığı için serviste durdu); Firma
 * Yetkilileri sekmesine, atama belgesi durumundan bağımsız kişi/iletişim bilgisi
 * taşıyan yeni bir "Sağlık ve Güvenlik Yetkilileri" bölümü (İş Yeri Hekimi/İş
 * Güvenliği Uzmanı) eklendi (bkz. getFirmaSaglikGuvenlikYetkilileri).
 *
 * Backlog #156 (backend #123): Evraklar sekmesi artık İKİ başlıklı grup — "Firma Belgeleri"
 * (Vergi Levhası/İmza Sirküsü/Faaliyet Belgesi + gruba sayılmayan Fuar Sözleşmesi) ve "Firma
 * İSG Belgeleri" (yukarıdaki üçlü) — ve ikisi de profile-page'in `belgeGruplari[]`ından,
 * `kod` ile eşlenerek basılıyor. Eski üç ayrı kaynak (profile.*Status stringleri, GET
 * /documents'tan Fuar Sözleşmesi, getFirmaBelgeleri'nin ikinci profile-page çağrısı) bu
 * sekmeden kalktı. Onaylanmamış her grup belgesi buradan yüklenebilir; Fuar Sözleşmesi hariç
 * (salt okunur, #156 kararı).
 *
 * Backlog #63 (2026-09-19, backend #62): Firma Yetkilileri sekmesi artık #62'nin rol
 * kataloğundan (`GET /firma/yetkili-rolleri`) türeyen gruplar hâlinde — İSG Yetkilileri
 * ve Firma Temsilcisi — ve bir grup BOŞ olsa da görünüyor. `users[]`ten türetilen eski
 * tekil "Firma Yetkilisi" kartı kaldırıldı: o kayıt firmanın portal HESABI sahibiydi,
 * Firma Temsilcisi ile aynı şey değil, ve zaten aşağıdaki "Kullanıcılar" bölümünde
 * listeleniyor (buna bağlı olarak firmaProfileService.getFirmaYetkilisi de silindi).
 * Gruplama mantığı iki sayfa arasında ortak: Components/Firma/yetkiliGruplari.js.
 *
 * Backlog #106 (2026-10-01, backend #105): Firma Temsilcisi rolünün etiketi "Firma
 * Yetkilisi" oldu (kod/grupKod 'firmaTemsilcisi'/'temsilci' sabit; etiket veri). O grup
 * sekmenin en ÜSTÜNDE ve profil kartıyla basılıyor — fotoğraf, departman, doğum tarihi,
 * LinkedIn, biyografi ve bağlı portal hesabı (Components/Firma/YetkiliProfil.jsx, iki
 * sayfada ortak). İSG rolleri ve "Kullanıcılar" bölümü olduğu gibi kaldı.
 *
 * Referans görsel /fromImageToLayout ile sağlandı. Dişli/ayarlar aksiyonları salt
 * okunur karar gereği hâlâ stub (infoMsg).
 *
 * Backlog #60 (2026-09-19, backend #61): "Firma Bilgileri" sekmesinin fotoğraf ve harita
 * placeholder'ları gerçek oldu, Katalog Bilgileri'nin stub "Düzenle"si çalışır hale geldi
 * ve firma logosu basılmaya başlandı. Üç blok da artık denetmen tarafındaki
 * FirmaProfilIncelemePage ile ORTAK: Components/Firma/FirmaBilgiKartlari.jsx (şerit kartı
 * ve InfoField de oraya taşındı). Galeri ayrı bir istek gerektirmiyor — profile-page
 * cevabı `fotograflar[]` ile birlikte latitude/longitude ve firmaLogoUrl'ı de taşıyor.
 * Harita leaflet + react-leaflet (#60'ta eklendi); döşemeler OpenStreetMap'ten gelir.
 *
 * 2026-07-23 revizyonu: ?tab=<key> query param'ı ile açılış sekmesi dışarıdan
 * seçilebilir hale geldi — Personel Listesi'ndeki "Firma İSG Belgeleri" kutucuğu
 * buraya ?tab=evraklar ile yönlendirir (bkz. FirmaPersonelListPage.jsx).
 *
 * 2026-08-10 revizyonu (mock→backend reconciliation, bkz.
 * docs/guides/FE-FirmaController-guide.md): seçili fuar 298/299 ise (LIVE_TEST_FUAR_IDS,
 * FirmaTaleplerListPage.jsx'teki aynı desen) 7 servis çağrısının hepsi forceLive:true ile
 * gerçek backend'e gidiyor, firmaId gerçek dekoratöre (TEST_DECORATOR_FIRMA_ID = 49858,
 * fuar 298'de tam dolu mock fixture) sabitleniyor. Firma Yetkilisi + Kullanıcılar sekmeleri
 * canlıda BOŞ görünür — backend'de user_to_firma satırı ekleyecek bir yazma endpoint'i yok
 * (rehberin "Asked for but not built" tablosu), bu yüzden mock veriyle doldurulamadı; bu bir
 * hata değil, gerçek durumun yansıması (bkz. docs/BACKEND_TODO.md). Görüşme Notları ve Fuar
 * Sözleşmesi için gerçek POST/upload endpoint'leri üzerinden "(mock)" etiketli test verisi
 * seed edildi.
 *
 * Backlog #251 (backend #200): Evraklar'da İSG grubu 99 İşveren İSG Görevlendirmesi kutusunu da taşır
 * (88+89 yerine geçer). #483 (backend #482): denetmen anahtarı KALKTI — 99 her Yerli firmaya sunulur ve
 * denetmen onaylayınca sayılır (bkz. FirmaProfilIncelemePage). Sayfa yalnızca `belgeGruplari`nın gönderdiğini
 * çizer; kutu notu belgeNotu'dan gelir ("Gruba sayılmaz" DEĞİL). Belgesi için kurumun verdiği boş form varsa
 * her kutuda "Şablonu indir" çıkar (documentTemplateService, yalnızca canlı fuarlarda).
 *
 * Backlog #388 (2026-10-19): mock (298 / 299 dışı) fuarlarda tek canlı okuma olan Fuar Katalog kartı,
 * `getCurrentFirmaId()`in MOCK_DECORATOR_FIRMA_ID (500) yedeğiyle firma 500'ün kataloğunu okuyordu; artık
 * girişin gerçek firmasını (`usePortal().firmaId`) alır.
 *
 * Backlog #212 (2026-10-13): Evraklar'ın tüm verisi canlı fuarda TEK çağrı — GET /firma/{id}/evraklar
 * (firmaService.getFirmaEvraklari): gruplar her belgenin satırıyla (`dosya`, eşlemeyi backend yapar),
 * fuarın ek belgeleri (`eksik`, `dosya`), erişim durumu, vergi no ve şablonlar. Diğer sekmeler kendi
 * çağrılarında; paylaşımlı SGK/İSG paneli de.
 */
import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Container, Card, CardBody, Row, Col, Nav, NavItem, NavLink, Badge, Spinner, Alert, Button, Table,
  Modal, ModalHeader, ModalBody, ModalFooter, Input, Label,
} from "reactstrap";
import {
  Building2, Pencil, ChevronUp, ChevronDown, FileText, Upload, UserPlus, UserCheck, Trash2, Download,
} from "lucide-react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DocumentPreviewModal from "../../Components/Common/DocumentPreviewModal";
import MainContext from "../../Components/Contexts/MainContext";
// WAS (until #528): import { FILE_APPROVAL_STATUS } from "../../services/projectService"; — only firmaBelgeStatusInfo read it, now in Components/Firma/belgeDurumu.js.
// #403: the live branch takes the logged-in company's id from the portal context (GET /portal/context).
import { usePortal } from "../../Components/Contexts/PortalContext";
// #436 / #437 / #438: düzenleme düğmeleri FIRMA_PROFILI modülü en az WRITE ise çizilir (backend aynı kuralı 403 ile zorlar).
import { enAz, MODUL, SEVIYE } from "../../services/portalService";
import { getFirmaDocumentFileUrl, firmaService } from "../../services/firmaService";
import {
  getFirmaProfile, getFirmaKullanicilar, getFirmaGorusmeNotlari,
  uploadFirmaGrupBelgesi, getFirmaSaglikGuvenlikYetkilileri, getYetkiliRolleri,
  createFirmaYetkilisi, updateFirmaYetkilisi, deleteFirmaYetkilisi,
  uploadYetkiliFotograf, deleteYetkiliFotograf,
  // WAS (until #403): MOCK_DECORATOR_FIRMA_ID, TEST_DECORATOR_FIRMA_ID, FUAR_SOZLESMESI_FILE_TYPE_ID,
  MOCK_DECORATOR_FIRMA_ID, FUAR_SOZLESMESI_FILE_TYPE_ID,
} from "../../services/firmaProfileService";
import {
  buildYetkiliGruplari, eklenebilirRoller, yetkiliIkonu, firmaYonetebilir, profilGrubuMu, isgYetkiliGrubuMu,
} from "../../Components/Firma/yetkiliGruplari";
import {
  YetkiliProfilKarti, YetkiliProfilAlanlari, EMPTY_YETKILI_FORM, EMPTY_YETKILI_FOTO,
  yetkiliFormundan, yetkiliPayload, yetkiliKaydet,
} from "../../Components/Firma/YetkiliProfil";
import YetkiliKullaniciSecModal from "../../Components/Firma/YetkiliKullaniciSecModal";
import FirmaBilgileriDuzenleModal from "../../Components/Firma/FirmaBilgileriDuzenleModal";
// WAS (until #528): ..., yabanciKatilimciBelgeGruplari, — the simple view showed only 78 + 79; now two sections (yabanciKatilimciEvrakBolumleri).
import {
  siraliBelgeGruplari, grupDurumInfo, belgeGorunenAd, belgeNotu, belgeUygulanamazMi, uygulanamazDurumu, grupUygulanamazMetni,
  yabanciKatilimciEvrakBolumleri, gerekliBelgelerDurumu, ISG_TAAHHUTNAMESI_FILE_TYPE_ID,
} from "../../Components/Firma/belgeGruplari";
import AcilirKart from "../../Components/Firma/AcilirKart";
import { firmaBelgeStatusInfo } from "../../Components/Firma/belgeDurumu";
import { fuarKatalogSekmesiAcik } from "../../Components/Firma/fuarKatalogSekmesi";
import { yabanciKatilimciMi } from "../../Components/Kisi/YabanciKatilimciParcalari";
import { sadePanelMi } from "../../services/sadePanel";
import YabanciKatilimciSahaDisiNotu from "../../Components/Firma/YabanciKatilimciSahaDisiNotu";
import PaylasimliBelgelerPanel from "../../Components/Firma/PaylasimliBelgelerPanel";
// WAS (until #503): import { bosFormSablonHaritasi } from "../../services/documentTemplateService"; -- blank forms only, examples showed nowhere.
import { sablonHaritasi } from "../../services/documentTemplateService";
import BelgeSablonuBaglantilari from "../../Components/Common/BelgeSablonuBaglantilari";
import IsgTaahhutnameIndir from "../../Components/Firma/IsgTaahhutnameIndir";
// #736: the company deletes its own pending / rejected uploaded document (backend #735); an approved one has no button (the backend refuses it).
import FirmaBelgeSilModal from "../../Components/Firma/FirmaBelgeSilModal";
// #613: "Kullanıcı Ekleme Talepleri" — the company asks SAKA for a new login (backend #612; staff decide, #614).
import {
  useKullaniciTalebi, KullaniciTalepDugmesi, KullaniciTalepModal, KullaniciTalepleriListesi,
} from "../../Components/Firma/KullaniciTalebi";

// #697: `grupKod` = the group the person is added to / edited in (the role select offers that group's roles); `hata` = a refused save, shown inside the window.
const EMPTY_YETKILI_MODAL = {
  isOpen: false, mode: "create", id: null, rol: "", grupKod: "", hata: null, form: EMPTY_YETKILI_FORM, foto: EMPTY_YETKILI_FOTO,
};
import {
  InfoRibbonCard, InfoField, FirmaLogo, KatalogBilgileriCard, FuarKatalogBilgileriCard,
  FirmaFotograflarCard, FirmaKonumCard,
} from "../../Components/Firma/FirmaBilgiKartlari";
import {
  setTaxNumber, uploadRequiredFirmaBelge, cardAccessModeMeta,
} from "../../services/cardAccessService";
import { useTranslation } from "react-i18next";
import i18n, { currentLocaleTag } from "../../i18n";
import TelefonGirdisi from "../../Components/Common/TelefonGirdisi";

function getCurrentFirmaId() {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.firmaId ?? MOCK_DECORATOR_FIRMA_ID;
  } catch {
    return MOCK_DECORATOR_FIRMA_ID;
  }
}

// 2026-08-10 reconciliation (bkz. docs/guides/FE-FirmaController-guide.md,
// util/knowledgebase/local-backend-testing.md) — FirmaTaleplerListPage.jsx'teki aynı
// isimli sabitin dosya-yerel kopyası. Seçili fuar 298/299 ise servis çağrıları
// forceLive:true ile gerçek backend'e gider ve firmaId gerçek dekoratöre
// (TEST_DECORATOR_FIRMA_ID = 49858) sabitlenir — localStorage'daki mock user.firmaId
// gerçek backend'de yok. Login gerçek firmaId dönmeye başladığında bu köprü kaldırılabilir.
// WAS (until #398): only the two seeded test fairs ran on the real backend, every other fair fell back to mock data:
// const LIVE_TEST_FUAR_IDS = [298, 299];
// const isLiveTestFuarId = (fuarId) => LIVE_TEST_FUAR_IDS.includes(Number(fuarId));
// #398: a full-simulation test creates a NEW fair, so every real fair id is live.
const isLiveTestFuarId = (fuarId) => Number(fuarId) > 0;

// #528: "Fuar Katalog Bilgileri" artık Bilgiler sekmesinin bir kartı değil, EN SON sekme (Evraklar'dan sonra); görünürlüğünü SAKA seçer
// (bkz. fuarKatalogSekmesi.js).
const TABS = [
  { key: "bilgiler", get label() { return i18n.t("portal:firmaKart.firmaBilgileri"); } },
  { key: "yetkililer", get label() { return i18n.t("portal:firmaKart.firmaYetkilileri"); } },
  { key: "evraklar", get label() { return i18n.t("portal:firmaKart.evraklar"); } },
  { key: "fuarKatalog", get label() { return i18n.t("portal:firmaKart.fuarKatalogBilgileri"); } },
];


// #528: firmaBelgeStatusInfo(status, zorunlu) Components/Firma/belgeDurumu.js'e taşındı (jest ile denensin; kayıtsız İSTENEN belge artık kırmızı).
// WAS (until #528):
// function firmaBelgeStatusInfo(status) {
//   const info = status != null ? FILE_APPROVAL_STATUS[status] : null;
//   return info ? { ...info, raw: status } : { label: i18n.t("portal:firmaKart.kayitYok"), color: "secondary", raw: null };
// }

// WAS (until #613): a gear button in the corner (title firmaKart.kullaniciYonetimi) that only said "User management will be added soon."
// A company never manages its logins itself (#409 D4 / #418): it asks SAKA with the section's "Add user" button (KullaniciTalebi.jsx).
function KullaniciCard({ user }) {
  const { t } = useTranslation("portal");
  const active = user.durum === "aktif";
  const accent = active ? "success" : "danger";
  return (
    <Col md={4} className="mb-3">
      <Card className={`h-100 border border-${accent}`} style={{ borderWidth: 2 }}>
        <CardBody>
          <InfoField label={t("firmaKart.kullanici")} value={user.adSoyad} />
          <InfoField label={t("firmaKart.email")} value={user.email} />
          <InfoField label={t("firmaKart.telefon")} value={user.telefon} />
          <InfoField label={t("firmaKart.unvan")} value={user.unvan} />
          <InfoField label={t("firmaKart.kayitTarihi")} value={user.kayitTarihi} />
          <InfoField label={t("firmaKart.sonGiris")} value={user.sonGiris} />
          <div className="small mb-0">
            <span className="text-muted">{t("firmaKart.rol")}</span> <span className="fw-semibold">{user.rol}</span>
          </div>
          <Badge color={accent} className="mt-2">{active ? t("firmaKart.aktif") : t("firmaKart.pasif")}</Badge>
        </CardBody>
      </Card>
    </Col>
  );
}

// #282 — GET /documents satırından kutucuğa taşınan red bilgisi. `satir.updateDate` reddedilmiş bir
// satırda red anıdır: yeniden yükleme satırı Beklemede'ye çevirir ve red gerekçesini siler.
function redBilgisi(satir) {
  if (!satir?.rejectReason) return null;
  let tarih = null;
  try { tarih = satir.updateDate ? new Date(satir.updateDate).toLocaleDateString(currentLocaleTag()) : null; } catch { /* tarih yok */ }
  return { neden: satir.rejectReason, tarih };
}

// #736 — firma yalnızca KENDİ yüklediği, ONAYLANMAMIŞ belgeyi siler (ham satır durumu 1 beklemede · 3 reddedilmiş); onaylı belge backend'de 403.
const silinebilir = (satir) => satir?.id != null && (satir.approvalStatus === 1 || satir.approvalStatus === 3);

// `sablon` ({ bosForm?, ornek? }, #251 / #503): kurumun bu belge için verdiği boş form (indir, imzala, yükle) ve örnek (nasıl görünmeli).
// `satir` (#282): bu kutucuğun GET /documents satırı — red nedeni ve gerçek dosya buradan; canlı
// görünümde yoksa (demo) önizleme eskisi gibi Lorem Ipsum'lu sahte sayfadır.
// #528: `istegeBagli` — "İsteğe bağlı" rozeti (istenmeyen belge); `bosFormIste` — kutuda HER ZAMAN bir "Boş formu indir" satırı çıkar: yayınlanmış
// bir şablon varsa bağlantı, yoksa pasif düğme + neden (İSG Taahhütnamesi: indir, imzala, geri yükle; belge sonradan konacak).
// #668: `uretilenForm` ({ firmaId, firmaAdi, fuarId }) — the "Download blank form" button makes the document's form for THIS company and fair (Firma
// İSG Taahhütnamesi PDF, #541) in the language the user selected: one button, not one per language. It replaces the published-template link and
// its "not published yet" button on that tile; the example link (if any) stays.
// #736: `onSil` — verilirse kutuda "Sil" düğmesi çıkar (yüklenmiş, onaylanmamış belge; onaylıda çağıran vermez, backend 403 verirdi).
function DocumentTile({ label, status, docKey, note, uploading = false, onUpload, onSil, sablon, red, satir, istegeBagli = false, bosFormIste = false, uretilenForm = null }) {
  const { t } = useTranslation("portal");
  const canUpload = !!onUpload && status.raw !== 1;
  const inputId = `firma-evrak-upload-${docKey}`;
  // Mock veride dosya adı/içerik yok, sadece durum kodu (raw) — raw dolu olması
  // bir belgenin gerçekten yüklenmiş olduğu anlamına gelir, bu durumda ikon/rozet
  // Lorem Ipsum'lu bir sayfa önizlemesi açar (bkz. DocumentPreviewModal).
  const [previewOpen, setPreviewOpen] = useState(false);
  const fileUrl = getFirmaDocumentFileUrl(satir?.filePath);
  const hasFile = status.raw != null || !!fileUrl;
  const yukleBloku = canUpload && (
    <>
      <input
        id={inputId}
        type="file"
        className="d-none"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onUpload(file);
          e.target.value = "";
        }}
      />
      <div className="mt-2">
        <Button
          color="primary" outline size="sm" disabled={uploading}
          onClick={() => document.getElementById(inputId)?.click()}
        >
          {uploading ? <Spinner size="sm" /> : <><Upload size={14} className="me-1" />{t("common:yukle")}</>}
        </Button>
      </div>
    </>
  );
  return (
    <Col md={4} sm={6} className="mb-3">
      <Card className="h-100 text-center">
        <CardBody>
          <div
            role={hasFile ? "button" : undefined}
            title={hasFile ? t("firmaKart.belgeyiOnizlemekIcinTiklayin") : undefined}
            style={{ cursor: hasFile ? "pointer" : undefined }}
            onClick={hasFile ? () => setPreviewOpen(true) : undefined}
          >
            <FileText size={28} className="text-muted mb-2" />
            <div className="small fw-semibold mb-2">{label}</div>
            {/* WAS (until #528): className={`rounded-pill py-1 text-white small fw-semibold bg-${status.color}`} — a light chip needs dark text. */}
            {/* WAS: bg-secondary for "Not applicable" — this theme maps secondary to teal-green, so the neutral chip read green. `gri` = the theme-proof gray. */}
            <div
              className={`rounded-pill py-1 small fw-semibold ${status.gri ? "" : `bg-${status.color}`} ${status.color === "light" ? "text-body border" : "text-white"}`}
              style={status.gri ? { background: "#878a99" } : undefined}
            >{status.label}</div>
            {istegeBagli && <div className="small fw-semibold text-muted mt-1" data-testid="belge-istege-bagli">{t("firmaKart.istegeBagli")}</div>}
            {red && (
              <div className="text-danger small mt-1">
                <span className="fw-semibold">{t("firmaKart.redNedeni")}</span> {red.neden}
                {red.tarih && <span className="text-muted"> · {red.tarih}</span>}
              </div>
            )}
            {note && <div className="text-muted small mt-1">{note}</div>}
          </div>
          <DocumentPreviewModal
            isOpen={previewOpen}
            toggle={() => setPreviewOpen(false)}
            fileName={satir?.fileGivenName || `${label}.pdf`}
            fileUrl={fileUrl || undefined}
          />
          {/* #503: the links moved to the shared component, which also offers the example ("View example"). WAS (until #503): an inline <a> for the
              blank form only. WAS (until #528): t("firmaKart.sablonuIndir") on every tile; the blank-form tile reads "Download blank form". */}
          {/* #618: on the blank-form tile (İSG Taahhütnamesi) "Upload" comes first and the blank-form links after it; every other tile keeps links first. */}
          {bosFormIste && yukleBloku}
          {/* #668: ONE "Download blank form" button that makes the form in the page language. WAS (#541): two buttons, Turkish | English; WAS (#667): the
              published template link only (BelgeSablonuBaglantilari sablon={sablon}). */}
          {uretilenForm && <IsgTaahhutnameIndir {...uretilenForm} tekDil etiket={t("firmaKart.bosFormuIndir")} />}
          <BelgeSablonuBaglantilari sablon={uretilenForm ? { ornek: sablon?.ornek } : sablon} bosFormEtiketi={bosFormIste ? t("firmaKart.bosFormuIndir") : undefined} />
          {!uretilenForm && !sablon?.bosForm && bosFormIste && (
            <div className="mt-2 small">
              <Button color="link" size="sm" className="p-0 text-muted" disabled title={t("firmaKart.bosFormHenuzYok")} data-testid="bos-form-yok">
                <Download size={12} className="me-1" />{t("firmaKart.bosFormuIndir")}
              </Button>
              <div className="text-muted" style={{ fontSize: "0.7rem" }}>{t("firmaKart.bosFormHenuzYok")}</div>
            </div>
          )}
          {!bosFormIste && yukleBloku}
          {onSil && (
            <div className="mt-2">
              <Button color="danger" outline size="sm" onClick={onSil} data-testid={`belge-sil-${docKey}`}>
                <Trash2 size={14} className="me-1" />{t("common:sil")}
              </Button>
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
}

export default function FirmaKartPage() {
  // #503: `i18n.language` also re-reads Evraklar when the language is switched, so the template links (served in the request language) follow it.
  const { t: tx, i18n: i18nHook } = useTranslation("portal");
  const { selectedFuarId } = useContext(MainContext);
  const portal = usePortal();
  const isLiveTestFuar = isLiveTestFuarId(selectedFuarId);
  // WAS (until #403): const firmaId = isLiveTestFuar ? TEST_DECORATOR_FIRMA_ID : getCurrentFirmaId();
  // null while /portal/context loads: the effects below wait for it instead of asking for firma "null".
  const firmaId = isLiveTestFuar ? (portal?.firmaId ?? null) : getCurrentFirmaId();
  // #388: on a fair that still reads MOCK data (not 298 / 299) `firmaId` above falls back to MOCK_DECORATOR_FIRMA_ID (500) because the
  // stored user carries no firmaId, and the Fuar Katalog card has no mock gate: it called the real backend for firma 500's catalog.
  // That card alone reads the real backend here, so it takes the login's real company (null while /portal/context loads or for
  // staff without a company: the card then says there is nothing, it never asks for 500).
  const gercekFirmaId = portal?.firmaId ?? null;
  const [searchParams] = useSearchParams();

  // Personel Listesi'ndeki "Firma İSG Belgeleri" kutucuğu gibi dış bağlantılar
  // ?tab=evraklar ile doğrudan Evraklar sekmesini açabilir (bkz.
  // FirmaPersonelListPage.jsx'teki PersonelDocTiles/goTo).
  const [activeTab, setActiveTab] = useState(() => {
    const requested = searchParams.get("tab");
    return TABS.some((t) => t.key === requested) ? requested : "bilgiler";
  });
  const [profile, setProfile] = useState(null);
  // Backlog #60 — galeri profile-page cevabının ÜST seviyesinde (`fotograflar[]`) geliyor,
  // bu yüzden ayrı bir istek yok; her yazma tazelenmiş listeyi döndüğü için state
  // doğrudan onunla değiştiriliyor (sayfa yeniden yüklenmiyor).
  const [fotograflar, setFotograflar] = useState([]);
  const [saglikGuvenlikYetkilileri, setSaglikGuvenlikYetkilileri] = useState([]);
  // WAS (until #528): const [yetkiliRolleri, setYetkiliRolleri] = useState([]); — now the catalogue as the backend sent it; `yetkiliRolleri` below renames one role.
  const [yetkiliRolleriHam, setYetkiliRolleri] = useState([]);
  // Backlog #82 — firma kendi Firma Yetkilisi kaydını yönetiyor (İSG rolleri denetmende kalır).
  const [yetkiliModal, setYetkiliModal] = useState(EMPTY_YETKILI_MODAL);
  const [savingYetkili, setSavingYetkili] = useState(false);
  const [yetkiliSilModal, setYetkiliSilModal] = useState({ isOpen: false, kisi: null, deleting: false });
  // #437: Firma Yetkilisi'ni firmanın kullanıcılarından seç. #438: firma bilgilerini düzenle.
  const [yetkiliSecModal, setYetkiliSecModal] = useState({ isOpen: false, mevcut: null });
  const [yetkiliSecHata, setYetkiliSecHata] = useState(null);
  const [savingYetkiliSec, setSavingYetkiliSec] = useState(false);
  const [bilgiModalAcik, setBilgiModalAcik] = useState(false);
  const [kullanicilar, setKullanicilar] = useState([]);
  const [gorusmeNotlari, setGorusmeNotlari] = useState([]);
  // #156 — iki firma belge grubu. #212: canlı fuarda GET /evraklar'dan, her belge kendi satırını
  // (`dosya`: red nedeni + gerçek dosya, #282) taşıyarak; demo görünümünde mock profile-page'den.
  const [belgeGruplari, setBelgeGruplari] = useState([]);
  // WAS (#282, #212 öncesi): GET /documents satırları, kutucuğa sayfada grupBelgesininSatiri ile eşleniyordu.
  // const [belgeSatirlari, setBelgeSatirlari] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [infoMsg, setInfoMsg] = useState(null);
  const [kullanicilarOpen, setKullanicilarOpen] = useState(true);
  const [uploadingGrupBelge, setUploadingGrupBelge] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);

  // Backlog #40/#41 — vergi numarası + fuara özel erişim durumu. Mock modu yok (bkz.
  // cardAccessService.js), bu yüzden sayfanın geri kalanı gibi yalnızca isLiveTestFuar iken
  // çekiliyor; aksi halde "demo görünümünde kullanılamaz" notu gösteriliyor.
  const [taxNumber, setTaxNumberState] = useState(null);
  const [taxNumberInput, setTaxNumberInput] = useState("");
  const [taxNumberEditing, setTaxNumberEditing] = useState(false);
  const [taxNumberSaving, setTaxNumberSaving] = useState(false);
  const [cardAccessStatus, setCardAccessStatus] = useState(null);
  // WAS (#212 öncesi): const [requiredBelgeTypes, setRequiredBelgeTypes] = useState([]);
  // #212: fuarın ek belgeleri, her biri `eksik` ve satırı (`dosya`) ile — evraklar.fuarBelgeleri.
  const [fuarBelgeleri, setFuarBelgeleri] = useState([]);
  const [uploadingFileTypeId, setUploadingFileTypeId] = useState(null);
  // #736: silme onay penceresindeki belge ({ id, ad, approvalStatus }) ya da null.
  const [belgeSilModal, setBelgeSilModal] = useState(null);
  // Backlog #251 — fileTypeId → { ad, url }: kurumun verdiği boş formlar ("Şablonu indir").
  const [sablonlar, setSablonlar] = useState({});

  useEffect(() => { document.title = i18n.t("portal:firmaKart.firmaKartiFds"); }, []);

  // KURAL: fetch mantığı bilinçli olarak Effect içinde tanımlanır (üst seviye
  // useCallback olarak paylaşılmaz) — aksi halde react-hooks/set-state-in-effect
  // ihlali oluşur. Yükleme sonrası reloadToken artırılarak yeniden çekilir.
  useEffect(() => {
    if (!firmaId) return undefined; // #403: no request before the portal has delivered the company
    let ignore = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        const opts = { forceLive: isLiveTestFuar, fuarId: selectedFuarId };
        // WAS (#212 öncesi): altıncı çağrı getFirmaDocumentRows(firmaId, opts).catch(() => []) — satırlar
        // artık evraklar efektinde, kutucuklara eşlenmiş geliyor.
        const [profileData, yetkiliRolData, saglikGuvenlikData, kullanicilarData, notlarData] = await Promise.all([
          getFirmaProfile(firmaId, opts),
          getYetkiliRolleri(opts),
          getFirmaSaglikGuvenlikYetkilileri(firmaId, opts),
          getFirmaKullanicilar(firmaId, opts),
          getFirmaGorusmeNotlari(firmaId, opts),
        ]);
        if (ignore) return;
        setProfile(profileData);
        setFotograflar(profileData?.fotograflar || []);
        // WAS: setBelgeGruplari(profileData?.belgeGruplari || []);
        // #212: canlıda gruplar evraklar efektinden gelir; burada yazılırsa geç dönen profile-page
        // satırları (`dosya`) taşıyan grupları ezerdi.
        if (!isLiveTestFuar) setBelgeGruplari(profileData?.belgeGruplari || []);
        // WAS: setBelgeSatirlari(satirlarData);
        setYetkiliRolleri(yetkiliRolData);
        setSaglikGuvenlikYetkilileri(saglikGuvenlikData);
        setKullanicilar(kullanicilarData);
        setGorusmeNotlari(notlarData);
      } catch (e) {
        if (!ignore) setError(e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [firmaId, isLiveTestFuar, selectedFuarId, reloadToken]);

  // Backlog #212 — Evraklar sekmesinin her şeyi TEK çağrıda (GET /firma/{id}/evraklar): belge grupları
  // satırlarıyla, fuarın ek belgeleri, erişim durumu (#40/#41), vergi numarası ve şablonlar (#251).
  // Eskiden üç ayrı efektte altı istekti (/documents, /tax-number, /kart-erisim, /firma-belge-kurallari,
  // /document-templates + profile-page'in grupları). Mock modu yok: demo görünümünde hiç çekilmiyor —
  // render tarafı isLiveTestFuar'a bakarak bu state'leri kullanmıyor, burada senkron setState'e gerek
  // yok (react-hooks/set-state-in-effect).
  useEffect(() => {
    // WAS (until #403): if (!isLiveTestFuar) return undefined;
    if (!isLiveTestFuar || !firmaId) return undefined;
    let ignore = false;
    async function run() {
      try {
        const evraklar = await firmaService.getFirmaEvraklari(firmaId, selectedFuarId);
        if (ignore) return;
        setBelgeGruplari(evraklar?.belgeGruplari || []);
        setFuarBelgeleri(evraklar?.fuarBelgeleri || []);
        setCardAccessStatus(evraklar?.kartErisim || null);
        setTaxNumberState(evraklar?.taxNumber ?? null);
        // WAS (until #503): setSablonlar(bosFormSablonHaritasi(evraklar?.sablonlar)); -- fileTypeId -> { ad, url } of the blank form only.
        setSablonlar(sablonHaritasi(evraklar?.sablonlar));
      } catch (e) {
        if (!ignore) setError(e.response?.data?.message || e.message);
      }
    }
    run();
    return () => { ignore = true; };
    // WAS (until #503): [firmaId, isLiveTestFuar, selectedFuarId, reloadToken]
  }, [firmaId, isLiveTestFuar, selectedFuarId, reloadToken, i18nHook.language]);

  // WAS (#212 öncesi) — iki ayrı efekt:
  //   #40/#41: Promise.all([getTaxNumber(firmaId), getFirmaCardAccessStatus(firmaId, selectedFuarId),
  //            getRequiredFirmaBelgeTypes(selectedFuarId)]) → setTaxNumberState / setCardAccessStatus / setRequiredBelgeTypes
  //   #251:    getBosFormSablonlari({ fuarId: selectedFuarId }).then(setSablonlar)

  async function handleSaveTaxNumber() {
    setTaxNumberSaving(true);
    setError(null);
    try {
      await setTaxNumber(firmaId, taxNumberInput.trim());
      setTaxNumberEditing(false);
      showInfo(tx("firmaKart.vergiNumarasiGuncellendi"));
      setReloadToken((t) => t + 1);
    } catch (e) {
      setError(e.message);
    } finally {
      setTaxNumberSaving(false);
    }
  }

  async function handleUploadRequiredBelge(fileTypeId, file) {
    setUploadingFileTypeId(fileTypeId);
    setError(null);
    try {
      await uploadRequiredFirmaBelge(firmaId, fileTypeId, selectedFuarId, file);
      showInfo(tx("firmaKart.belgeYuklendiOnayBekleniyor"));
      setReloadToken((t) => t + 1);
    } catch (e) {
      setError(e.message);
    } finally {
      setUploadingFileTypeId(null);
    }
  }

  function showInfo(msg) {
    setInfoMsg(msg);
    setTimeout(() => setInfoMsg(null), 3500);
  }

  async function handleUploadGrupBelgesi(belge, file) {
    setUploadingGrupBelge(belge.fileTypeId);
    setError(null);
    try {
      await uploadFirmaGrupBelgesi(firmaId, belge, file, { forceLive: isLiveTestFuar, fuarId: selectedFuarId });
      showInfo(tx("firmaKart.belgeYuklendiOnayBekleniyor"));
      setReloadToken((t) => t + 1);
    } catch (e) {
      setError(e.response?.data?.message || e.message);
    } finally {
      setUploadingGrupBelge(null);
    }
  }

  // #528 (2026-10-21, Deniz / Bilge): bu sayfada profil grubunun (Firma Yetkilisi) adı "Company Executive" okunur. Ad rol kataloğundan gelir
  // ve İngilizcesi backend'de (R__text_catalogs_en.sql: 'Company Representative'); backend değişene kadar sayfa kendi çevirisini kullanır
  // (başlık, ekleme penceresi, "kullanıcıdan seç" penceresi hepsi bu rolü okur). Backend de "Company Executive" derse bu satır gereksizleşir.
  const yetkiliRolleri = yetkiliRolleriHam.map((r) => (
    profilGrubuMu(r) ? { ...r, ad: tx("firmaKart.firmaYoneticisi"), grupAd: tx("firmaKart.firmaYoneticisi") } : r
  ));
  // #62/#63 — gruplar, başlıkları ve sıraları rol kataloğundan türüyor. Yetkili
  // satırları `grupSira` taşımadığı için katalog olmadan gruplar doğru sıralanamaz.
  const tumYetkiliGruplari = buildYetkiliGruplari(saglikGuvenlikYetkilileri, yetkiliRolleri);
  // #82 — firmanın ekleyebileceği roller: dolu `tekil` roller düşer, atama belgesi
  // isteyen roller (İSG) zaten firmaya kapalıydı; #443 (2026-10-18): artık İSG de firmanın, `firmaYonetebilir` hepsine true.
  const firmaEkleyebilirRoller = eklenebilirRoller(yetkiliRolleri, saglikGuvenlikYetkilileri)
    .filter(firmaYonetebilir);
  const seciliYetkiliRol = yetkiliRolleri.find((r) => r.kod === yetkiliModal.rol) || null;
  // #697: the roles the add / edit window offers = the group's roles the company may manage (an edit keeps the row's own `tekil` role). One role = fixed
  // (Company Executive); several (the İSG group) = a select, so an İş Güvenliği Uzmanı can be added and an edit can change the role.
  // WAS: the role field was always disabled and "Ekle" saved grupRolleri[0] (İşyeri Hekimi) for every İSG person.
  const yetkiliModalRolleri = eklenebilirRoller(yetkiliRolleri, saglikGuvenlikYetkilileri, yetkiliModal.id)
    .filter((r) => firmaYonetebilir(r) && (r.grupKod ?? "") === yetkiliModal.grupKod);
  // #436: bu girişin portal rolü firmanın kendi profilini değiştirebiliyor mu (FIRMA_PROFILI ≥ WRITE)? Personel önizlemesinde
  // (#411) her seviye READ'e iner, yani düğmeler çizilmez. profilYazabilir: canlı fuar kartlarının (mock'u olmayan yazma
  // uçları) düzenleme düğmeleri; portalYazabilir: demo görünümünde de çalışan yetkili düğmeleri.
  const portalYazabilir = enAz(portal?.seviye?.(MODUL.FIRMA_PROFILI), SEVIYE.WRITE);
  const profilYazabilir = isLiveTestFuar && portalYazabilir;
  // #613: "Add user" request — the same WRITE rule as the Edit buttons; Organizatör / Taşeron sets cannot send one (backend #612 b), so nothing is asked for them.
  const kullaniciTalebi = useKullaniciTalebi(firmaId, {
    etkin: profilYazabilir && !["ORGANIZATOR", "TASERON"].includes(portal?.aktif?.rol), fuarId: selectedFuarId,
  });
  // #437: firmanın "kullanıcıdan seç" ile atayabileceği rol: profil grubunun, firmanın yönetebildiği (atama belgesi istemeyen)
  // rolü. Bugün tek rol var (Firma Yetkilisi); ikinci bir rol eklenirse modalda bir rol seçici gerekir.
  const yetkiliSecRol = yetkiliRolleri.find((r) => profilGrubuMu(r) && firmaYonetebilir(r)) || null;
  const firmaYabanci = profile?.firmaNation === 2 || Boolean(portal?.aktif?.yabanci);
  // #511: Yabancı Katılımcı Evraklar'da yalnızca İmza Sirküsü + İSG Taahhütnamesi'ni görür (paylaşımlı SGK / İSG belgeleri de yok).
  // #742: istenen yalnızca İSG Taahhütnamesi; İmza Sirküsü alttaki isteğe bağlı "Firma Evrakları" kartında.
  // #704: bilerek sadePanelMi DEĞİL: bu sayfada `yabanciKatilimci`nın değiştirdiği her şey belge (Evraklar'ın iki bölümü, İSG yetkilileri,
  // paylaşımlı belgeler). Sade panel modunda Yerli bir firma kendi gruplarını backend'in gönderdiği gibi görür (zorunlu belgeleri, İSG
  // yetkilileri dahil); Yerli / Yabancı ayrımı korunur (Deniz 2026-11-03). Kapanan modüllerin sekmeleri (Fuar Katalog) modülden gelir.
  const yabanciKatilimci = yabanciKatilimciMi(portal);
  // #740 (Deniz 2026-11-05): Sade panel modu AÇIKKEN YABANCI bir firma, hangi setten girerse girsin (Yabancı Dekoratör, Organizatör, ...), Evraklar'ı
  // ve İSG yetkilileri kararını gerçek Yabancı Katılımcı gibi görür; backend #742'den beri yabancı Katılımcıya da Dekoratöre de aynı firma belgelerini sorar,
  // yani [79] listesi onlar için de doğrudur. Yerli firma Sade panelde bile kendi grup grup Evraklar'ını ve İSG yetkililerini korur (zorunlu belgeleri farklı;
  // düzen [79]'u sabit yazar, #704'ün belge riski). Anahtar KAPALIYKEN yalnızca gerçek Yabancı Katılımcı. Not (YabanciKatilimciSahaDisiNotu) bilerek
  // yabanciKatilimci'da kalır: dekoratör kurulumda alandadır.
  const yabanciEvrakDuzeni = yabanciKatilimci || (sadePanelMi(portal) && firmaYabanci);
  // #528: Yabancı Katılımcı'nın Firma Yetkilileri sekmesinde İSG yetkilileri ("OHS Officers") grubu yok. WAS: tumYetkiliGruplari'nın hepsi çizilirdi.
  // Kapsam bilerek YALNIZCA Yabancı Katılımcı: Yerli firmanın İSG kişileri (#443) olduğu gibi kalır. Tüm setlere yaymak için `yabanciKatilimci &&` kalkar.
  // WAS (until #740): !(yabanciKatilimci && isgYetkiliGrubuMu(g))
  const yetkiliGruplari = tumYetkiliGruplari.filter((g) => !(yabanciEvrakDuzeni && isgYetkiliGrubuMu(g)));
  // #528: Fuar Katalog sekmesi görünür mü (SAKA'nın seçimi), ve sekme listesi.
  const katalogSekmesi = fuarKatalogSekmesiAcik(portal);
  const tabs = TABS.filter((t) => t.key !== "fuarKatalog" || katalogSekmesi);
  const aktifSekme = tabs.some((t) => t.key === activeTab) ? activeTab : "bilgiler";
  // #528: Yabancı Katılımcı'nın Evraklar bölümleri (üstte istenenler, altta isteğe bağlılar); diğer setlerde null (eski görünüm).
  // WAS (until #740): yabanciKatilimci ? ... : null
  const yabanciBolumleri = yabanciEvrakDuzeni ? yabanciKatilimciEvrakBolumleri(belgeGruplari) : null;
  // #435: bu firma vergi numarası borçlu mu? Backend söyler (kart-erisim taxNumberGerekli, #434); cevap gelene kadar uyruk karar verir.
  const vergiNoGerekli = cardAccessStatus ? cardAccessStatus.taxNumberGerekli !== false : !firmaYabanci;

  // #697: a group with one role opens with it fixed; a group with several (İSG) opens with NO role chosen (Kaydet waits for it): nothing is picked for the company.
  function openYetkiliCreate(grupRolleri) {
    setYetkiliModal({
      ...EMPTY_YETKILI_MODAL, isOpen: true,
      grupKod: grupRolleri[0].grupKod ?? "", rol: grupRolleri.length === 1 ? grupRolleri[0].kod : "",
    });
  }

  function openYetkiliEdit(kisi) {
    setYetkiliModal({
      isOpen: true, mode: "edit", id: kisi.id, rol: kisi.rol || "", grupKod: kisi.grupKod ?? "", hata: null,
      form: yetkiliFormundan(kisi),
      foto: { ...EMPTY_YETKILI_FOTO, mevcutUrl: kisi.fotografUrl || null },
    });
  }

  async function handleYetkiliSave() {
    const { mode, id, rol, form, foto } = yetkiliModal;
    if (!form.adSoyad.trim() || !rol) return;
    // #697: no fair = the demo view; the service would write to its in-memory list ("saved", gone after a reload). Refuse instead.
    if (!isLiveTestFuar) {
      setYetkiliModal((m) => ({ ...m, hata: tx("firmaKart.yetkiliFuarGerekli") }));
      return;
    }
    setSavingYetkili(true);
    setError(null);
    setYetkiliModal((m) => ({ ...m, hata: null }));
    try {
      const opts = { forceLive: isLiveTestFuar };
      // #106: profil alanları ve fotoğraf yalnızca profil grubunun rolünde gönderilir.
      const { liste, fotoHatasi } = await yetkiliKaydet({
        mode, id, foto, oncekiListe: saglikGuvenlikYetkilileri,
        payload: yetkiliPayload(rol, form, profilGrubuMu(seciliYetkiliRol)),
        api: {
          create: (p) => createFirmaYetkilisi(firmaId, p, opts),
          update: (rid, p) => updateFirmaYetkilisi(firmaId, rid, p, opts),
          uploadFoto: (rid, f) => uploadYetkiliFotograf(firmaId, rid, f, opts),
          deleteFoto: (rid) => deleteYetkiliFotograf(firmaId, rid, opts),
        },
      });
      setSaglikGuvenlikYetkilileri(liste);
      setYetkiliModal(EMPTY_YETKILI_MODAL);
      if (fotoHatasi) setError(fotoHatasi);
      else showInfo(mode === "edit" ? tx("firmaKart.yetkiliGuncellendi") : tx("firmaKart.yetkiliEklendi"));
    } catch (e) {
      // WAS: setError(e.response?.data?.message || e.message) - the page alert, behind the window that stays open until a save succeeds.
      setYetkiliModal((m) => ({ ...m, hata: e.response?.data?.message || e.message }));
    } finally {
      setSavingYetkili(false);
    }
  }

  function openYetkiliSec() {
    if (!yetkiliSecRol) return;
    const mevcut = saglikGuvenlikYetkilileri.find((k) => k.rol === yetkiliSecRol.kod) || null;
    setYetkiliSecHata(null);
    setYetkiliSecModal({ isOpen: true, mevcut });
  }

  // #437: kayıt yoksa oluşturulur, varsa AYNI kayıt güncellenir (rol `tekil`: bir firmada bir Firma Yetkilisi). Güncelleme PUT'tur,
  // yani yalnızca gönderilen alanlar değişir: departman, doğum tarihi, LinkedIn, biyografi ve fotoğraf korunur.
  async function handleYetkiliSecKaydet(v) {
    // #697: no fair = the demo view, whose writes go to an in-memory list; refuse (the message shows inside the window).
    if (!isLiveTestFuar) {
      setYetkiliSecHata(tx("firmaKart.yetkiliFuarGerekli"));
      return;
    }
    setSavingYetkiliSec(true);
    setYetkiliSecHata(null);
    try {
      const opts = { forceLive: isLiveTestFuar };
      const mevcut = yetkiliSecModal.mevcut;
      const payload = {
        rol: v.rol, adSoyad: v.adSoyad, unvan: v.unvan, telefon: v.telefon, email: v.email, kullaniciId: v.kullaniciId,
      };
      const liste = mevcut
        ? await updateFirmaYetkilisi(firmaId, mevcut.id, payload, opts)
        : await createFirmaYetkilisi(firmaId, payload, opts);
      setSaglikGuvenlikYetkilileri(liste);
      setYetkiliSecModal({ isOpen: false, mevcut: null });
      showInfo(mevcut ? tx("firmaKart.yetkiliGuncellendi") : tx("firmaKart.yetkiliEklendi"));
    } catch (e) {
      setYetkiliSecHata(e.response?.data?.message || e.message);
    } finally {
      setSavingYetkiliSec(false);
    }
  }

  // #528: bir grup belgesinin kutucuğu (iki Evraklar görünümü de bunu kullanır). `istegeBagli`: "İsteğe bağlı" rozeti; `bosFormIste`: her zaman
  // "Boş formu indir" satırı (İSG Taahhütnamesi: indir, imzala, geri yükle).
  function belgeKutusu(b, grup, { istegeBagli = false, bosFormIste = false } = {}) {
    // WAS: const satir = grupBelgesininSatiri(belgeSatirlari, b, selectedFuarId);
    // #212: backend eşliyor (aynı kural); yüklenmemişse `dosya` yok.
    // #442: UYGULANAMAZ belge nötr gri, yükleme düğmesi / şablon / dosya yok, nedeni notta.
    const uygulanamaz = belgeUygulanamazMi(b);
    const satir = uygulanamaz ? null : (b.dosya ?? null);
    return (
      <DocumentTile
        key={b.fileTypeId}
        label={belgeGorunenAd(b.fileTypeId, b.ad)}
        docKey={`grup-${b.fileTypeId}`}
        // WAS: status={firmaBelgeStatusInfo(b.status)}
        // WAS (until #528): status={uygulanamaz ? { ...uygulanamazDurumu(), raw: null } : firmaBelgeStatusInfo(b.status)} — no record of a required document read teal-green.
        status={uygulanamaz ? { ...uygulanamazDurumu(), raw: null, gri: true } : firmaBelgeStatusInfo(b.status, b.zorunlu)}
        note={belgeNotu(b, grup)}
        satir={satir}
        // Kutucuk durumu sözleşme numaralamasında: 2 = Reddedildi.
        red={!uygulanamaz && b.status === 2 ? redBilgisi(satir) : null}
        sablon={uygulanamaz ? undefined : sablonlar[b.fileTypeId]}
        uploading={uploadingGrupBelge === b.fileTypeId}
        onUpload={uygulanamaz || b.fileTypeId === FUAR_SOZLESMESI_FILE_TYPE_ID
          ? undefined
          : (file) => handleUploadGrupBelgesi(b, file)}
        // #736: Delete on an uploaded, not-yet-approved document (live view only; the Fuar Sözleşmesi is not the company's to upload, so not its to delete).
        onSil={isLiveTestFuar && !uygulanamaz && b.fileTypeId !== FUAR_SOZLESMESI_FILE_TYPE_ID && silinebilir(satir)
          ? () => setBelgeSilModal({ id: satir.id, ad: belgeGorunenAd(b.fileTypeId, b.ad), approvalStatus: satir.approvalStatus })
          : undefined}
        istegeBagli={istegeBagli}
        bosFormIste={bosFormIste}
        // #668: the İSG Taahhütnamesi form is made for this company and fair (needs a real company and fair: the demo view has neither).
        uretilenForm={!uygulanamaz && isLiveTestFuar && firmaId && selectedFuarId && b.fileTypeId === ISG_TAAHHUTNAMESI_FILE_TYPE_ID
          ? { firmaId, firmaAdi: profile?.firmaName || portal?.firma?.firmaName || "", fuarId: selectedFuarId }
          : null}
      />
    );
  }

  async function handleYetkiliDelete() {
    const { kisi } = yetkiliSilModal;
    if (!kisi) return;
    // #697: no fair = the demo view, whose delete only touches an in-memory list; refuse (the window closes so the page alert is seen).
    if (!isLiveTestFuar) {
      setError(tx("firmaKart.yetkiliFuarGerekli"));
      setYetkiliSilModal({ isOpen: false, kisi: null, deleting: false });
      return;
    }
    setYetkiliSilModal((m) => ({ ...m, deleting: true }));
    setError(null);
    try {
      const liste = await deleteFirmaYetkilisi(firmaId, kisi.id, { forceLive: isLiveTestFuar });
      setSaglikGuvenlikYetkilileri(liste);
      setYetkiliSilModal({ isOpen: false, kisi: null, deleting: false });
      showInfo(tx("firmaKart.kaydiSilindi", { adSoyad: kisi.adSoyad }));
    } catch (e) {
      setError(e.response?.data?.message || e.message);
      setYetkiliSilModal((m) => ({ ...m, deleting: false }));
    }
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={tx("firmaKart.firmaKarti")} pageTitle={tx("firmaKart.firma")} />

        {error && <Alert color="danger">{error}</Alert>}
        {infoMsg && <Alert color="info">{infoMsg}</Alert>}

        {/* Backlog #40/#41 — vergi numarası + erişim durumu. Sayfanın geri kalanı gibi salt
            okunur değil: bu tek alan, personel işlemlerinin önündeki gerçek engel olduğu için
            buradan düzenlenebilir. */}
        {/* WAS (until #622): {!loading && isLiveTestFuar && ( - a foreign company saw this banner too (its card mode, a hint and an optional tax
            number with a red Edit); nothing enforces a tax number for it since #434, so it sees none (Deniz, 2026-10-30). The optional field stays in
            the company-information Edit window. */}
        {!loading && isLiveTestFuar && vergiNoGerekli && (
          <Alert color={cardAccessStatus ? cardAccessModeMeta(cardAccessStatus.cardAccessMode).color : "secondary"} className="mb-4">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div>
                <div className="fw-semibold">
                  {cardAccessStatus ? cardAccessModeMeta(cardAccessStatus.cardAccessMode).label : tx("firmaKart.erisimDurumuYukleniyor")}
                </div>
                {/* WAS (until #622, a foreign company's lines - it sees no banner now): for FULL the "all documents are complete" line
                    (firmaKart.yabanciTamErisimIpucu) instead of the mode's hint, and a "does not need a tax number" note
                    (firmaKart.yabanciVergiNoGerekmez; since #535 not for the Yabancı Katılımcı). */}
                {cardAccessStatus && <div className="small">{cardAccessModeMeta(cardAccessStatus.cardAccessMode).hint}</div>}
              </div>
              <div className="d-flex align-items-center gap-2">
                {!taxNumberEditing ? (
                  <>
                    <span className="small">
                      <span className="text-muted">{tx("firmaKart.vergiNo")}</span>{" "}
                      <span className="fw-semibold">{taxNumber || tx("firmaKart.girilmedi")}</span>
                    </span>
                    {portalYazabilir && (
                      <Button
                        size="sm" color="danger" /* WAS (until #535 follow-up): color="light" outline — white on white, invisible */
                        onClick={() => { setTaxNumberInput(taxNumber || ""); setTaxNumberEditing(true); }}
                      >
                        <Pencil size={12} className="me-1" />{tx("common:duzenle")}
                      </Button>
                    )}
                  </>
                ) : (
                  <>
                    <input
                      className="form-control form-control-sm" style={{ width: 160 }}
                      value={taxNumberInput} onChange={(e) => setTaxNumberInput(e.target.value)}
                      placeholder={tx("firmaKart.vergiNumarasi")}
                    />
                    <Button size="sm" color="primary" disabled={taxNumberSaving} onClick={handleSaveTaxNumber}>
                      {taxNumberSaving ? <Spinner size="sm" /> : tx("common:kaydet")}
                    </Button>
                    <Button size="sm" color="light" onClick={() => setTaxNumberEditing(false)}>{tx("firmaKart.vazgec")}</Button>
                  </>
                )}
              </div>
            </div>
          </Alert>
        )}
        {!loading && !isLiveTestFuar && (
          <Alert color="secondary" className="mb-4 small">
            {tx("firmaKart.vergiNumarasiVeFuarEvrak")}
          </Alert>
        )}

        {loading && (
          <div className="text-center py-5">
            <Spinner color="primary" />
            <p className="mt-2">{tx("common:yukleniyor")}</p>
          </div>
        )}

        {!loading && profile && (
          <>
            <Card className="mb-4 overflow-hidden">
              <div className="bg-light">
                <div className="p-4">
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    <div
                      className="bg-white rounded-3 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0"
                      style={{ width: 64, height: 64 }}
                    >
                      <Building2 size={32} className="text-danger" />
                    </div>
                    <div>
                      <h4 className="text-dark mb-0">{profile.firmaName}</h4>
                      <div className="text-muted small">{profile.firmaShortName}</div>
                    </div>
                  </div>
                </div>
                <Nav pills className="px-4 gap-2 border-0" style={{ position: "relative" }} data-tour="firmakart-sekmeler">
                  {/* WAS (until #528): {TABS.map(...) with activeTab — now `tabs` / `aktifSekme` (the Fuar Katalog tab can be switched off by SAKA). */}
                  {tabs.map((t) => (
                    <NavItem key={t.key}>
                      <NavLink
                        active={aktifSekme === t.key}
                        data-tour={`firmakart-sekme-${t.key}`}
                        className={aktifSekme === t.key ? "bg-danger text-white" : "bg-white text-dark"}
                        style={{ cursor: "pointer", borderRadius: "6px 6px 0 0" }}
                        onClick={() => setActiveTab(t.key)}
                      >
                        {t.label}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>
              </div>
            </Card>

            {aktifSekme === "bilgiler" && (
              <>
                {/*
                  Backlog #60: firma logosu artık basılıyor (profile-page'in firmaLogoUrl +
                  firmaLogoSource alanları, #61) — ham firmaLogo sütunu dosyanın nerede
                  durduğunu söylemediği için eskiden gösterilemiyordu. Ad/kısa ad/uyruk
                  düzenlemesi firma tarafında YOK (o kayıt denetmen tarafında, #33) — eski
                  "yakında eklenecek" stub butonu bu yüzden kaldırıldı, yerine gerçekten
                  düzenlenebilen Katalog ve Konum kartlarının kendi butonları geldi.
                */}
                {/* WAS (until #528): label={tx("firmaKart.firmaBilgileri")} — the tab keeps that name; the top section reads "Company Profile". */}
                <InfoRibbonCard
                  tour="firmakart-profil"
                  label={tx("firmaKart.firmaProfiliBolumu")}
                  actions={profilYazabilir ? (
                    // WAS (until #615): icon only — <Pencil size={14} /> with no text; the other Edit buttons on this tab read pencil + "Edit".
                    <Button color="danger" size="sm" title={tx("common:duzenle")} onClick={() => setBilgiModalAcik(true)}>
                      <Pencil size={14} className="me-1" />{tx("common:duzenle")}
                    </Button>
                  ) : null}
                >
                  <Row>
                    <Col md={6}>
                      <div className="d-flex align-items-center gap-3 mb-3">
                        <FirmaLogo profile={profile} size={56} />
                        <div className="fw-semibold">{profile.firmaName}</div>
                      </div>
                      <InfoField label={tx("firmaKart.firmaKisaAdi")} value={profile.firmaShortName} />
                      <InfoField label={tx("firmaKart.adres")} value={profile.adres} />
                    </Col>
                    <Col md={6}>
                      <InfoField label={tx("firmaKart.ePosta")} value={profile.eposta} />
                      <InfoField label={tx("firmaKart.telefon")} value={profile.telefon} />
                      <div className="mb-2 small">
                        <span className="text-muted">{tx("firmaKart.webSitesi")}</span>{" "}
                        {profile.webSitesi ? (
                          // Mock veri şema öneki içermiyordu ("www.foo.com"), gerçek profile-page
                          // kaydı içeriyor ve sona " (mock)" ekliyor (firma 49858) — href bir şema
                          // + boşluk içeren domain'le kırılmasın diye ikisi de temizleniyor,
                          // görüntülenen metin ham haliyle kalıyor.
                          <a
                            href={`//${profile.webSitesi.replace(/^[a-zA-Z]+:\/\//, "").split(/\s+/)[0]}`}
                            target="_blank" rel="noreferrer" className="text-danger fw-semibold"
                          >
                            {profile.webSitesi}
                          </a>
                        ) : "—"}
                      </div>
                    </Col>
                  </Row>
                </InfoRibbonCard>

                {/*
                  Backlog #60: bu üç blok artık denetmen tarafındaki Firma Profili İncele
                  sayfasıyla ORTAK (Components/Firma/FirmaBilgiKartlari.jsx). Yazma uçlarının
                  mock karşılığı yok, bu yüzden düzenleme sayfanın geri kalanıyla aynı şekilde
                  canlı test fuarına bağlı (#41'deki aynı desen).
                */}
                {/* #528: the card reads "Areas of Activities and Services" (TR "İştigal Alanları ve Hizmetleri", #539; WAS "Business Activities") on this page (the staff pages keep "Catalogue Information"). */}
                <KatalogBilgileriCard
                  tour="firmakart-faaliyet"
                  variant="ribbon"
                  label={tx("firmaKart.isFaaliyetleri")}
                  modalBaslik={tx("firmaKart.isFaaliyetleriniDuzenle")}
                  firmaId={firmaId}
                  profile={profile}
                  canEdit={profilYazabilir}
                  onSaved={() => setReloadToken((t) => t + 1)}
                />

                {/* WAS (until #528) — Backlog #104 (FE half of #103): the FuarKatalogBilgileriCard (global katalogtan AYRI, seçili fuara özel) was the
                    4th card here; it is the last TAB now (aktifSekme === "fuarKatalog" below):
                <FuarKatalogBilgileriCard
                  variant="ribbon"
                  firmaId={gercekFirmaId}   (WAS until #388: firmaId={firmaId})
                  fuarId={selectedFuarId}
                  canEdit={profilYazabilir}
                /> */}

                <FirmaFotograflarCard
                  tour="firmakart-fotograflar"
                  variant="ribbon"
                  firmaId={firmaId}
                  photos={fotograflar}
                  canEdit={profilYazabilir}
                  onChanged={setFotograflar}
                />

                <FirmaKonumCard
                  tour="firmakart-konum"
                  variant="ribbon"
                  firmaId={firmaId}
                  profile={profile}
                  canEdit={profilYazabilir}
                  onSaved={() => setReloadToken((t) => t + 1)}
                />
              </>
            )}

            {aktifSekme === "yetkililer" && (
              <>
                {/*
                  Backlog #63: eskiden burada `users[]`ten türetilen tek bir "Firma
                  Yetkilisi" kartı vardı — o kayıt firmanın PORTAL HESABI sahibiydi
                  (userGroupName "Firma Moderatör"), #62'nin Firma Temsilcisi'yle (#105'ten beri
                  "Firma Yetkilisi") aynı şey değil. Kart kaldırıldı: portal hesapları zaten
                  hemen aşağıdaki "Kullanıcılar" bölümünde listeleniyor, yetkililer ise artık
                  rol kataloğundan gelen gruplar hâlinde basılıyor. Gruplar BOŞ olsa bile
                  görünür, yoksa "Firma Yetkilisi atanmamış" bilgisi hiç okunamazdı.
                  #106: Firma Yetkilisi grubu en üstte ve profil kartıyla basılıyor
                  (buildYetkiliGruplari sıralıyor, YetkiliProfilKarti çiziyor).
                */}
                {yetkiliGruplari.map((grup) => {
                  // #82 — bu gruba firma kendisi ekleyebiliyor mu? (Atama belgesi isteyen
                  // İSG grubunda liste boş kalır, buton hiç basılmaz.)
                  const grupRolleri = firmaEkleyebilirRoller.filter((r) => r.grupKod === grup.grupKod);
                  return (
                  <InfoRibbonCard
                    label={grup.grupAd}
                    key={grup.grupKod || "diger"}
                    tour={profilGrubuMu(grup) ? "firmakart-yetkili" : undefined}
                    // WAS (until #437 / #436): actions={grupRolleri.length > 0 ? (<Button ... UserPlus /> ) : null} — yalnızca Ekle, rol seviyesine bakmadan
                    actions={portalYazabilir && (grupRolleri.length > 0 || (profilGrubuMu(grup) && yetkiliSecRol)) ? (
                      <>
                        {/* WAS (until #617): both buttons color="light" outline, icon only — white on white; now solid red with their text like the page's other buttons. */}
                        {profilGrubuMu(grup) && yetkiliSecRol && (
                          <Button color="danger" size="sm" className="me-1" title={tx("firmaKart.kullanicilardanSec")} onClick={openYetkiliSec}>
                            <UserCheck size={14} className="me-1" />{tx("firmaKart.kullanicilardanSec")}
                          </Button>
                        )}
                        {grupRolleri.length > 0 && (
                          <Button color="danger" size="sm" title={tx("common:ekle")} onClick={() => openYetkiliCreate(grupRolleri)}>
                            <UserPlus size={14} className="me-1" />{tx("common:ekle")}
                          </Button>
                        )}
                      </>
                    ) : null}
                  >
                    {grup.kisiler.length === 0 && profilGrubuMu(grup) ? (
                      // #616: an empty profile group (Company Executive) draws the filled card's template with empty values instead of a single text line;
                      // WAS: <div className="text-muted small">{tx("firmaKart.buGrubaKayitliYetkiliBulunamadi")}</div> for every group.
                      <YetkiliProfilKarti kisi={{}} />
                    ) : grup.kisiler.length === 0 ? (
                      <div className="text-muted small">{tx("firmaKart.buGrubaKayitliYetkiliBulunamadi")}</div>
                    ) : profilGrubuMu(grup) ? (
                      grup.kisiler.map((k, i) => (
                        <div key={k.id} className={i > 0 ? "border-top mt-3 pt-3" : ""}>
                          <YetkiliProfilKarti
                            kisi={k}
                            actions={firmaYonetebilir(k) && portalYazabilir && (
                              <>
                                {/* WAS (until #615): icon only — <Pencil size={14} /> with no text. */}
                                <Button color="danger" size="sm" title={tx("common:duzenle")} onClick={() => openYetkiliEdit(k)}>
                                  <Pencil size={14} className="me-1" />{tx("common:duzenle")}
                                </Button>
                                <Button
                                  color="danger" outline size="sm" title={tx("common:sil")}
                                  onClick={() => setYetkiliSilModal({ isOpen: true, kisi: k, deleting: false })}
                                >
                                  <Trash2 size={14} />
                                </Button>
                              </>
                            )}
                          />
                        </div>
                      ))
                    ) : (
                      <Row>
                        {grup.kisiler.map((k) => {
                          const RolIcon = yetkiliIkonu(k);
                          return (
                            <Col lg={6} key={k.id} className="mb-3">
                              <div className="d-flex align-items-start gap-3">
                                <div
                                  className="rounded-3 bg-light d-flex align-items-center justify-content-center flex-shrink-0"
                                  style={{ width: 56, height: 56 }}
                                >
                                  <RolIcon size={26} className="text-muted" />
                                </div>
                                <div className="text-break flex-grow-1" style={{ minWidth: 0 }}>
                                  <Badge color="light" className="text-body border mb-1">
                                    {k.rolAd || k.rol || tx("firmaKart.bilinmeyenRol")}
                                  </Badge>
                                  <InfoField label={tx("firmaKart.adSoyad")} value={k.adSoyad} />
                                  <InfoField label={tx("firmaKart.unvan")} value={k.unvan} />
                                  <InfoField label={tx("firmaKart.telefon")} value={k.telefon} />
                                  <InfoField label={tx("firmaKart.email")} value={k.email} />
                                </div>
                                {firmaYonetebilir(k) && portalYazabilir && (
                                  <div className="d-flex gap-1 flex-shrink-0">
                                    {/* WAS (until #615): icon only — <Pencil size={14} /> with no text. */}
                                    <Button color="danger" size="sm" title={tx("common:duzenle")} onClick={() => openYetkiliEdit(k)}>
                                      <Pencil size={14} className="me-1" />{tx("common:duzenle")}
                                    </Button>
                                    <Button
                                      color="danger" outline size="sm" title={tx("common:sil")}
                                      onClick={() => setYetkiliSilModal({ isOpen: true, kisi: k, deleting: false })}
                                    >
                                      <Trash2 size={14} />
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                    )}
                  </InfoRibbonCard>
                  );
                })}

                <InfoRibbonCard
                  tour="firmakart-kullanicilar"
                  label={tx("firmaKart.kullanicilar")}
                  actions={
                    <>
                      <KullaniciTalepDugmesi talep={kullaniciTalebi} onAc={() => setKullanicilarOpen(true)} />
                      <Button
                        color="light" outline size="sm" title={kullanicilarOpen ? tx("firmaKart.daralt") : tx("firmaKart.genislet")}
                        onClick={() => setKullanicilarOpen((o) => !o)}
                      >
                        {kullanicilarOpen ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                      </Button>
                    </>
                  }
                >
                  {kullanicilarOpen && (
                    <>
                      {kullanicilar.length === 0 ? (
                        <div className="text-muted small">{tx("firmaKart.kullaniciBulunamadi")}</div>
                      ) : (
                        <Row>
                          {kullanicilar.map((u) => (
                            <KullaniciCard key={u.id} user={u} />
                          ))}
                        </Row>
                      )}
                      <KullaniciTalepleriListesi firmaId={firmaId} talep={kullaniciTalebi} />
                    </>
                  )}
                  <KullaniciTalepModal firmaId={firmaId} talep={kullaniciTalebi} />
                </InfoRibbonCard>

                <InfoRibbonCard label={tx("firmaKart.gorusmeNotlari")} tour="firmakart-gorusme">
                  {gorusmeNotlari.length === 0 ? (
                    <div className="text-muted small">{tx("firmaKart.gorusmeNotuBulunamadi")}</div>
                  ) : (
                    <div className="table-responsive">
                      <Table className="align-middle mb-0" borderless>
                        <thead>
                          <tr className="text-muted small text-uppercase">
                            <th>{tx("firmaKart.tarih")}</th>
                            <th>{tx("firmaKart.saat")}</th>
                            <th>{tx("firmaKart.gorusulen")}</th>
                            <th>{tx("firmaKart.denetmen")}</th>
                            <th>{tx("firmaKart.gorusmeTipi")}</th>
                            <th>{tx("firmaKart.gorusmeNotu")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {gorusmeNotlari.map((n) => (
                            <tr key={n.id}>
                              <td className="small">{n.tarih}</td>
                              <td className="small">{n.saat}</td>
                              <td className="small text-danger fw-semibold">{n.gorusulen}</td>
                              <td className="small text-danger fw-semibold">{n.denetmen}</td>
                              <td className="small">{n.gorusmeTipi}</td>
                              <td className="small">{n.not}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </InfoRibbonCard>
              </>
            )}

            {aktifSekme === "evraklar" && (
              <>
                {/* #558: Yabancı Katılımcı'ya "fuar saatleri dışında alanda kimse yoksa belge yüklemeniz gerekmez" (başka setlerde render etmez). */}
                <YabanciKatilimciSahaDisiNotu />

                {/* #528: Yabancı Katılımcı iki bölüm görür — ÜSTTE istenen iki belge (İSG Taahhütnamesi en üstte, sonra İmza Sirküsü; İSG Taahhütnamesi
                    kutusunda boş formu indir düğmesi), ALTTA geri kalan firma belgeleri varsayılan KAPALI "Firma Evrakları" kartında, hepsi "İsteğe bağlı".
                    Paylaşımlı SGK / İSG belgeleri paneli bu kullanıcıda yok (aşağıdaki !yabanciKatilimci koşulu).
                    #742 (2026-11-04): ÜSTTE yalnızca İSG Taahhütnamesi; İmza Sirküsü alttaki "Firma Evrakları" kartına indi (isteğe bağlı, yüklenebilir). */}
                {yabanciBolumleri && (
                  <InfoRibbonCard
                    tour="firmakart-evrak-isg"
                    label={tx("firmaKart.gerekliBelgeler")}
                    actions={<Badge color={gerekliBelgelerDurumu(yabanciBolumleri.gerekli).color}>{gerekliBelgelerDurumu(yabanciBolumleri.gerekli).label}</Badge>}
                  >
                    <Row>
                      {yabanciBolumleri.gerekli.map(({ belge, grup }) => belgeKutusu(belge, grup, { bosFormIste: belge.fileTypeId === ISG_TAAHHUTNAMESI_FILE_TYPE_ID }))}
                    </Row>
                  </InfoRibbonCard>
                )}

                {/* WAS (until #528): (yabanciKatilimci ? yabanciKatilimciBelgeGruplari(belgeGruplari) : siraliBelgeGruplari(belgeGruplari)).map(...) */}
                {/* WAS (until #740): {!yabanciKatilimci && siraliBelgeGruplari(belgeGruplari).map(...) */}
                {!yabanciEvrakDuzeni && siraliBelgeGruplari(belgeGruplari).map((grup) => {
                  const durum = grupDurumInfo(grup);
                  return (
                    <InfoRibbonCard
                      key={grup.kod}
                      tour={grup.kod === "ISG" ? "firmakart-evrak-isg" : grup.kod === "FIRMA" ? "firmakart-evrak-firma" : undefined}
                      label={grup.baslik}
                      actions={<Badge color={durum.color}>{durum.label}</Badge>}
                    >
                      {/* #442: grubun UYGULANAMAZ belgeleri (backend #440 / #441) yazılı olarak da belirtilir. */}
                      {grupUygulanamazMetni(grup) && <div className="text-muted small mb-2">{grupUygulanamazMetni(grup)}</div>}
                      <Row>
                        {grup.belgeler.map((b) => belgeKutusu(b, grup))}
                      </Row>
                    </InfoRibbonCard>
                  );
                })}

                {/* Backlog #40/#41 — bu FUARA özel, genişleyebilir belge listesi
                    (fuar_firma_belge_kural) — yukarıdaki iki gruptan ayrı bir kavram. */}
                {/* WAS (#212 öncesi): requiredBelgeTypes (GET /fuar/{id}/firma-belge-kurallari) + kart-erisim'in
                    missingFileTypeIds + grupBelgesininSatiri ile yalnızca fuar satırı. */}
                {isLiveTestFuar && fuarBelgeleri.length > 0 && (
                  <InfoRibbonCard label={tx("firmaKart.buFuarinIstedigiEkBelgeler")}>
                    <Row>
                      {fuarBelgeleri.map((t) => {
                        const missing = t.eksik;
                        // #282 — reddedilmiş bir belge de "eksik" sayılır; satırı varsa "Eksik" yerine
                        // "Reddedildi" + neden yazılır. Burada kutucuk durumu yok, ham satır durumuna
                        // bakılır (3 = Reddedildi). #212: satır bu fuarınki, yoksa firma geneli (kart-erisim
                        // ikisini de sayar).
                        const satir = t.dosya ?? null;
                        const reddedildi = missing && satir?.approvalStatus === 3;
                        const status = reddedildi
                          ? { label: tx("firmaKart.reddedildi"), color: "danger" }
                          : missing
                            ? { label: tx("firmaKart.eksik"), color: "danger" }
                            : { label: tx("firmaKart.tamamlandi"), color: "success" };
                        return (
                          <DocumentTile
                            key={t.fileTypeId}
                            label={t.fileTypeName || tx("firmaKart.belge", { fileTypeId: t.fileTypeId })}
                            docKey={`fuar-belge-${t.fileTypeId}`}
                            status={status}
                            satir={satir}
                            red={reddedildi ? redBilgisi(satir) : null}
                            sablon={sablonlar[t.fileTypeId]}
                            uploading={uploadingFileTypeId === t.fileTypeId}
                            // Tamamlanmış bir belgede yükleme kapanır — DocumentTile'ın
                            // canUpload'u onUpload'un varlığına bakıyor (status.raw bu
                            // belgeler için yok, firmaBelgeStatusInfo'nun aksine).
                            onUpload={missing ? (file) => handleUploadRequiredBelge(t.fileTypeId, file) : undefined}
                            // #736: a pending or rejected upload can be deleted (an approved one cannot).
                            onSil={silinebilir(satir)
                              ? () => setBelgeSilModal({
                                id: satir.id, ad: t.fileTypeName || tx("firmaKart.belge", { fileTypeId: t.fileTypeId }), approvalStatus: satir.approvalStatus,
                              })
                              : undefined}
                          />
                        );
                      })}
                    </Row>
                  </InfoRibbonCard>
                )}

                {/* Backlog #142 — SGK Hizmet Dökümü / İSG Eğitim Katılım Listesi: firmanın belgesi,
                    çalışanlarına dağıtılır. Yalnızca canlı görünümde (mock'u yok). */}
                {/* WAS (until #740): isLiveTestFuar && !yabanciKatilimci && ... */}
                {isLiveTestFuar && !yabanciEvrakDuzeni && <PaylasimliBelgelerPanel firmaId={firmaId} />}

                {/* #528: Yabancı Katılımcı'nın geri kalan firma belgeleri en altta, varsayılan KAPALI, hepsi "İsteğe bağlı". */}
                {yabanciBolumleri && yabanciBolumleri.digerleri.length > 0 && (
                  <AcilirKart baslik={tx("firmaKart.firmaEvraklari")} varsayilanAcik={false} tour="firmakart-evrak-firma">
                    <div className="text-muted small mb-2">{tx("firmaKart.istegeBagliBelgelerNotu")}</div>
                    <Row>
                      {yabanciBolumleri.digerleri.map(({ belge, grup }) => belgeKutusu(belge, grup, { istegeBagli: true }))}
                    </Row>
                  </AcilirKart>
                )}
              </>
            )}

            {/* #528 — Fuar Katalog Bilgileri: Evraklar'dan sonraki EN SON sekme (WAS: Bilgiler sekmesinin 4. kartı). Görünürlüğünü SAKA seçer
                (fuarKatalogSekmesi.js); düzenleme FIRMA_PROFILI en az WRITE ister. */}
            {aktifSekme === "fuarKatalog" && (
              <FuarKatalogBilgileriCard
                variant="ribbon"
                /* WAS (until #388): firmaId={firmaId} */
                firmaId={gercekFirmaId}
                fuarId={selectedFuarId}
                canEdit={profilYazabilir}
              />
            )}
          </>
        )}

        {/* #82 — firmanın kendi yetkili kaydı için ekleme/düzenleme. #697: rol, grupta birden çok rol varsa (İSG) bir seçici,
            tek rol varsa (Firma Yetkilisi) sabit alan; WAS (#82 / #443): her zaman sabit, yani her İSG kişisi İşyeri Hekimi kaydedilirdi.
            Reddedilen kayıt (hata) pencerenin içinde söylenir: pencere yalnızca başarıda kapanır. */}
        <Modal isOpen={yetkiliModal.isOpen} toggle={() => setYetkiliModal(EMPTY_YETKILI_MODAL)}>
          <ModalHeader toggle={() => setYetkiliModal(EMPTY_YETKILI_MODAL)}>
            {yetkiliModal.mode === "edit" ? tx("firmaKart.yetkiliyiDuzenle") : tx("firmaKart.yetkiliEkle")}
          </ModalHeader>
          <ModalBody>
            {yetkiliModal.hata && <Alert color="danger" className="small py-2">{yetkiliModal.hata}</Alert>}
            <div className="mb-2">
              <Label className="small">{tx("firmaKart.rol2")}</Label>
              {yetkiliModalRolleri.length > 1 ? (
                <Input
                  type="select" bsSize="sm" value={yetkiliModal.rol}
                  onChange={(e) => setYetkiliModal((m) => ({ ...m, rol: e.target.value, hata: null }))}
                >
                  <option value="">{tx("firmaKart.rolSecin")}</option>
                  {yetkiliModalRolleri.map((r) => <option key={r.id ?? r.kod} value={r.kod}>{r.ad}</option>)}
                </Input>
              ) : (
                <Input bsSize="sm" value={seciliYetkiliRol?.ad || yetkiliModal.rol} disabled />
              )}
            </div>
            <div className="mb-2">
              <Label className="small">{tx("firmaKart.adSoyad2")}</Label>
              <Input
                bsSize="sm" value={yetkiliModal.form.adSoyad}
                onChange={(e) => setYetkiliModal((m) => ({ ...m, form: { ...m.form, adSoyad: e.target.value } }))}
              />
            </div>
            <div className="mb-2">
              <Label className="small">{tx("firmaKart.unvan")}</Label>
              <Input
                bsSize="sm" value={yetkiliModal.form.unvan} placeholder={seciliYetkiliRol?.unvanIpucu || ""}
                onChange={(e) => setYetkiliModal((m) => ({ ...m, form: { ...m.form, unvan: e.target.value } }))}
              />
            </div>
            <Row>
              <Col md={6}>
                <Label className="small">{tx("firmaKart.telefon")}</Label>
                <TelefonGirdisi
                  bsSize="sm" value={yetkiliModal.form.telefon}
                  onChange={(v) => setYetkiliModal((m) => ({ ...m, form: { ...m.form, telefon: v } }))}
                />
              </Col>
              <Col md={6}>
                <Label className="small">{tx("firmaKart.email")}</Label>
                <Input
                  bsSize="sm" value={yetkiliModal.form.email}
                  onChange={(e) => setYetkiliModal((m) => ({ ...m, form: { ...m.form, email: e.target.value } }))}
                />
              </Col>
            </Row>
            {profilGrubuMu(seciliYetkiliRol) && (
              <YetkiliProfilAlanlari
                form={yetkiliModal.form}
                onFormChange={(form) => setYetkiliModal((m) => ({ ...m, form }))}
                foto={yetkiliModal.foto}
                onFotoChange={(foto) => setYetkiliModal((m) => ({ ...m, foto }))}
                kullanicilar={kullanicilar}
              />
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setYetkiliModal(EMPTY_YETKILI_MODAL)}>{tx("common:iptal")}</Button>
            <Button
              color="primary"
              disabled={!yetkiliModal.form.adSoyad.trim() || !yetkiliModal.rol || savingYetkili}
              onClick={handleYetkiliSave}
            >
              {savingYetkili ? <Spinner size="sm" /> : tx("common:kaydet")}
            </Button>
          </ModalFooter>
        </Modal>

        {/* #437 — Firma Yetkilisi'ni firmanın kendi kullanıcılarından seç (YetkiliKullaniciSecModal). */}
        {yetkiliSecModal.isOpen && yetkiliSecRol && (
          <YetkiliKullaniciSecModal
            toggle={() => setYetkiliSecModal({ isOpen: false, mevcut: null })}
            kullanicilar={kullanicilar}
            rol={yetkiliSecRol}
            mevcut={yetkiliSecModal.mevcut}
            saving={savingYetkiliSec}
            hata={yetkiliSecHata}
            onKaydet={handleYetkiliSecKaydet}
          />
        )}

        {/* #438 — firma bilgilerini düzenle (FirmaBilgileriDuzenleModal). Kısmi kayıtta modal açık kalır ve hatayı kendi içinde söyler. */}
        {bilgiModalAcik && (
          <FirmaBilgileriDuzenleModal
            toggle={() => setBilgiModalAcik(false)}
            firmaId={firmaId}
            profile={profile}
            taxNumber={taxNumber}
            vergiNoGoster={isLiveTestFuar && !loading}
            yabanci={firmaYabanci}
            onSaved={({ tamam }) => {
              if (tamam) {
                setBilgiModalAcik(false);
                showInfo(tx("firmaKart.firmaBilgileriGuncellendi"));
              }
              setReloadToken((t) => t + 1);
            }}
          />
        )}

        <Modal
          isOpen={yetkiliSilModal.isOpen}
          toggle={() => setYetkiliSilModal({ isOpen: false, kisi: null, deleting: false })}
        >
          <ModalHeader toggle={() => setYetkiliSilModal({ isOpen: false, kisi: null, deleting: false })}>
            {tx("firmaKart.yetkiliyiSil")}
          </ModalHeader>
          <ModalBody>
            <p className="mb-2">
              <strong>{yetkiliSilModal.kisi?.adSoyad}</strong>
              {yetkiliSilModal.kisi?.rolAd ? ` (${yetkiliSilModal.kisi.rolAd})` : ""}{" "}{tx("firmaKart.kaydiKaliciOlarakSilinecek")}
            </p>
            <div className="text-muted small"><strong>{tx("firmaKart.geriAlinamaz")}</strong></div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setYetkiliSilModal({ isOpen: false, kisi: null, deleting: false })}>
              {tx("common:iptal")}
            </Button>
            <Button color="danger" disabled={yetkiliSilModal.deleting} onClick={handleYetkiliDelete}>
              {yetkiliSilModal.deleting ? <Spinner size="sm" /> : tx("common:sil")}
            </Button>
          </ModalFooter>
        </Modal>

        {/* #736: Delete an uploaded company document (backend #735); the tile goes back to "no record" after the list is read again. */}
        {belgeSilModal && (
          <FirmaBelgeSilModal
            key={belgeSilModal.id} firmaId={firmaId} belge={belgeSilModal}
            onClose={() => setBelgeSilModal(null)}
            onDeleted={(mesaj) => {
              setBelgeSilModal(null);
              showInfo(mesaj);
              setReloadToken((n) => n + 1);
            }}
          />
        )}
      </Container>
    </div>
  );
}
